var render = function render(){var _vm=this,_c=_vm._self._c;return _c('the-btn',{attrs:{"text":_vm.text,"btnClass":'btn btn-outline-custom btn-sm',"disabled":_vm.disabled},nativeOn:{"click":function($event){return _vm.onClick.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }